(function () {
  var ROOT = document.querySelector('.pw');
  if (!ROOT) return;
  var scene = ROOT.querySelector('.pw__scene');
  var win = ROOT.querySelector('.pw-win[data-window="projector"]');
  var screenEl = ROOT.querySelector('.pw__screen');
  var bar = ROOT.querySelector('.pw__screen-bar');
  if (!scene || !win || scene.querySelector('.ph')) return;

  /* the dark wall, in pixels of the 5760 x 960 master */
  var MW = 5760, MH = 960;
  function wallTop(x) { return 149 + 0.195 * (x - 4725); }
  function wallFloor(x) { return 749 - 0.0711 * (x - 4875); }
  var WIDEST = 4440, NARROWEST = 4700, FAR = 5080, T1 = 0.24, T2 = 0.66, BH = 320;

  var ph = document.createElement('div');
  ph.className = 'ph';
  ph.setAttribute('role', 'dialog');
  ph.setAttribute('aria-label', 'The Parade Tapes');
  ph.innerHTML = '<div class="ph__wash"></div><div class="ph__scan"></div>' +
    '<div class="ph__in">' +
      '<div class="ph__head"><span class="ph__title">The Parade Tapes</span>' +
        '<button type="button" class="ph__close" aria-label="Close">&times;</button></div>' +
      '<div class="ph__cols">' +
        '<div class="ph__col"><div class="ph__label">Folders</div><ul class="ph__list ph__folders"></ul></div>' +
        '<div class="ph__rule"></div>' +
        '<div class="ph__col"><div class="ph__label">Tapes</div><ul class="ph__list ph__tapes"></ul></div>' +
      '</div>' +
    '</div>';
  scene.appendChild(ph);
  var fl = ph.querySelector('.ph__folders'), tl = ph.querySelector('.ph__tapes');

  var FOLDER = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6.5h6l2 2h10v10H3z" fill="rgba(234,241,255,.28)" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>';
  var LAMP = '<span class="ph__lamp" aria-hidden="true"></span>';
  var state = { on: false, folder: null, fPage: 0, tPage: 0, rows: 5 };
  var folderData = [], tapeData = [];

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function shown(li) { return !li.hidden && li.style.display !== 'none'; }

  function readTapes() {
    var folders = [];
    win.querySelectorAll('.pw-nav__folder').forEach(function (b) {
      var name = b.getAttribute('data-folder');
      var files = [];
      win.querySelectorAll('.pw-nav__files li').forEach(function (li) {
        if (li.getAttribute('data-folder') !== name || !shown(li)) return;
        var f = li.querySelector('.pw-nav__file');
        if (f) files.push({ name: f.textContent.trim(), btn: f, playing: f.classList.contains('is-playing') });
      });
      if (files.length) folders.push({ name: name, files: files });
    });
    return folders;
  }

  function page(items, key, kind, row) {
    var rows = state.rows, per = items.length > rows ? Math.max(1, rows - 1) : rows;
    var pages = Math.max(1, Math.ceil(items.length / per));
    if (state[key] > pages - 1) state[key] = 0;
    var s = state[key] * per, h = '';
    items.slice(s, s + per).forEach(function (it, n) { h += row(it, s + n); });
    if (pages > 1) h += '<li><button type="button" class="ph__more" data-more="' + kind + '">' +
      (state[key] < pages - 1 ? 'More &darr;' : 'From the top &uarr;') + '</button></li>';
    return h;
  }

  function render() {
    var folders = readTapes();
    folderData = folders;
    if (!folders.length) { fl.innerHTML = '<li class="ph__empty">No tapes yet</li>'; tl.innerHTML = ''; tapeData = []; return; }
    var live = null;
    folders.forEach(function (f) { f.files.forEach(function (t) { if (t.playing) live = f.name; }); });
    var cur = folders.filter(function (f) { return f.name === state.folder; })[0];
    if (!cur) {
      cur = folders.filter(function (f) { return f.name === live; })[0] || folders[0];
      state.folder = cur.name; state.tPage = 0;
    }
    tapeData = cur.files;
    fl.innerHTML = page(folders, 'fPage', 'f', function (f, i) {
      var on = f.name === cur.name;
      return '<li><button type="button" class="ph__it' + (on ? ' is-on' : '') + '" data-f="' + i + '"' +
        (on ? ' aria-current="true"' : '') + '>' + FOLDER + '<span class="ph__nm">' + esc(f.name) + '</span>' +
        (f.name === live ? LAMP : '') + '</button></li>';
    });
    tl.innerHTML = page(cur.files, 'tPage', 't', function (t, i) {
      return '<li><button type="button" class="ph__it ph__tape' + (t.playing ? ' is-on' : '') + '" data-t="' + i + '"' +
        (t.playing ? ' aria-current="true"' : '') + '>' + (t.playing ? LAMP : '') +
        '<span class="ph__nm">' + esc(t.name) + '</span></button>' +
        (t.playing ? '<button type="button" class="ph__stop" aria-label="Stop the tape">&#9632;</button>' : '') + '</li>';
    });
  }

  ph.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b) return;
    if (b.classList.contains('ph__close')) { setOn(false); return; }
    if (b.dataset.more) { state[b.dataset.more === 'f' ? 'fPage' : 'tPage']++; render(); return; }
    if (b.classList.contains('ph__stop')) {
      var s = win.querySelector('.pw-tapes__stop');
      if (s) s.click();
      setTimeout(render, 60);
      return;
    }
    if (b.dataset.f != null) {
      var f = folderData[+b.dataset.f];
      if (f && f.name !== state.folder) { state.folder = f.name; state.tPage = 0; render(); }
      return;
    }
    if (b.dataset.t != null) {
      var t = tapeData[+b.dataset.t];
      if (t && !t.playing) { t.btn.click(); setTimeout(render, 60); setTimeout(showPicture, 160); }
    }
  });
  /* a tap on the list is a tap, not the start of a drag across the world */
  ['pointerdown', 'mousedown', 'touchstart'].forEach(function (t) {
    ph.addEventListener(t, function (e) { if (e.target.closest('button')) e.stopPropagation(); }, { passive: true });
  });

  /* a projective warp from a flat card onto four corners, so its lines run
     toward the wall's vanishing point */
  function solve(src, dst) {
    var A = [], b = [], i, r, c, k;
    for (i = 0; i < 4; i++) {
      var x = src[i][0], y = src[i][1], u = dst[i][0], v = dst[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    for (c = 0; c < 8; c++) {
      var p = c;
      for (r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[p][c])) p = r;
      var t = A[c]; A[c] = A[p]; A[p] = t; t = b[c]; b[c] = b[p]; b[p] = t;
      for (r = c + 1; r < 8; r++) {
        var f = A[r][c] / A[c][c];
        for (k = c; k < 8; k++) A[r][k] -= f * A[c][k];
        b[r] -= f * b[c];
      }
    }
    var hh = [];
    for (i = 7; i >= 0; i--) {
      var s = b[i];
      for (k = i + 1; k < 8; k++) s -= A[i][k] * hh[k];
      hh[i] = s / A[i][i];
    }
    return hh;
  }
  function m3d(H) {
    return 'matrix3d(' + [H[0], H[3], 0, H[6], H[1], H[4], 0, H[7], 0, 0, 1, 0, H[2], H[5], 0, 1].join(',') + ')';
  }
  function warpTo(el, q, h) {
    var mw = (q[1][0] - q[0][0] + q[2][0] - q[3][0]) / 2, mh = (q[3][1] - q[0][1] + q[2][1] - q[1][1]) / 2;
    var w = Math.max(40, Math.round(h * mw / mh));
    return { w: w, m: m3d(solve([[0, 0], [w, 0], [w, h], [0, h]], q)) };
  }

  /* the film's picture, as the section draws it, in scene pixels */
  function picture() {
    if (!screenEl) return null;
    var d = screenEl.dataset, narrow = window.innerWidth < 750, portrait = d.orientation === 'portrait';
    var raw = narrow ? (portrait ? d.cornersMobilePortrait : d.cornersMobile) : (portrait ? d.cornersPortrait : d.corners);
    var n = String(raw || '').split(',').map(parseFloat);
    if (n.length < 8 || n.some(isNaN)) return null;
    var w = scene.offsetWidth, h = scene.offsetHeight;
    return [0, 2, 4, 6].map(function (i) { return [n[i] / 100 * w, n[i + 1] / 100 * h]; });
  }
  function meet(a, b, c, d) {
    var den = (a[0] - b[0]) * (c[1] - d[1]) - (a[1] - b[1]) * (c[0] - d[0]);
    if (Math.abs(den) < 1e-6) return null;
    var p = a[0] * b[1] - a[1] * b[0], q = c[0] * d[1] - c[1] * d[0];
    return [(p * (c[0] - d[0]) - (a[0] - b[0]) * q) / den, (p * (c[1] - d[1]) - (a[1] - b[1]) * q) / den];
  }
  function placeBar() {
    if (!bar) return;
    var P = picture(), ht = scene.offsetHeight;
    if (!P || !ht) return;
    var cx = (P[2][0] + P[3][0]) / 2;
    var slope = (P[2][1] - P[3][1]) / ((P[2][0] - P[3][0]) || 1);
    var yb = P[3][1] + slope * (cx - P[3][0]);
    var half = Math.max(Math.abs(P[2][0] - P[3][0]) / 2, 0.2 * ht);
    var x0 = cx - half, x1 = cx + half;
    var V = meet(P[0], P[1], P[3], P[2]);
    if (V && V[0] > x0 - 1 && V[0] < x1 + 1) V = null;
    function along(y, x) { return V ? V[1] + (y - V[1]) * (x - V[0]) / (cx - V[0]) : y + slope * (x - cx); }
    var a = yb + 0.016 * ht, b2 = a + 0.05 * ht;
    var q = [[x0, along(a, x0)], [x1, along(a, x1)], [x1, along(b2, x1)], [x0, along(b2, x0)]];
    var over = Math.max(q[2][1], q[3][1]) - (ht - 4);
    if (over > 0) q.forEach(function (p) { p[1] -= over; });
    var r = warpTo(bar, q, 64);
    bar.classList.add('pb');
    bar.style.setProperty('--pb-w', r.w + 'px');
    bar.style.setProperty('--pb-m', r.m);
  }

  function place() {
    var w = scene.offsetWidth, ht = scene.offsetHeight;
    if (!w || !ht) return;
    var k = (scene.getBoundingClientRect().height / ht) || 1;
    var s = w / MW;
    var vpEl = ROOT.querySelector('.pw__viewport');
    var room = ((vpEl ? vpEl.clientWidth : window.innerWidth) - 32) / (s * k);
    var x1 = Math.min(NARROWEST, Math.max(WIDEST, FAR - room));
    var q = [[x1, T1], [FAR, T1], [FAR, T2], [x1, T2]].map(function (p) {
      var top = wallTop(p[0]), fl2 = wallFloor(p[0]);
      return [p[0] * s, (top + p[1] * (fl2 - top)) / MH * ht];
    });
    var r = warpTo(ph, q, BH);
    ph.style.width = r.w + 'px';
    ph.style.transform = r.m;
    /* keep the nearest line readable on whatever screen this is */
    var near = (q[3][1] - q[0][1]) * k / BH;
    var fs = Math.max(22, Math.min(48, 16 / (near || 1)));
    ph.style.setProperty('--fs', fs.toFixed(1) + 'px');
    var rows = Math.max(2, Math.floor((BH - fs * 2.85 - 4) / (fs * 1.55)));
    if (rows !== state.rows) { state.rows = rows; if (state.on) render(); }
    placeBar();
  }

  /* narrow screens cannot hold the whole room: glide the world so the list
     is fully in view, the same nudge the other windows use */
  function reveal() {
    var vp = ROOT.querySelector('.pw__viewport');
    if (!vp) return;
    var v = vp.getBoundingClientRect(), r = ph.getBoundingClientRect(), m = 16, dx = 0;
    if (r.left < v.left + m) dx = r.left - (v.left + m);
    else if (r.right > v.right - m) dx = Math.min(r.right - (v.right - m), r.left - (v.left + m));
    if (Math.abs(dx) > 2) vp.dispatchEvent(new WheelEvent('wheel', { deltaY: dx, deltaX: 0, deltaMode: 0, bubbles: true, cancelable: true }));
  }

  /* after a tape is picked, glide the world so its picture is in view;
     on a phone the list and the screen cannot both fit at once */
  function showPicture() {
    var vp = ROOT.querySelector('.pw__viewport'), pic = screenEl && screenEl.querySelector('.pw__screen-inner');
    if (!vp || !pic) return;
    var v = vp.getBoundingClientRect(), r = pic.getBoundingClientRect();
    if (!r.width || (r.left >= v.left + 8 && r.right <= v.right - 8)) return;
    var dx = (r.left + r.width / 2) - (v.left + v.width / 2);
    vp.dispatchEvent(new WheelEvent('wheel', { deltaY: dx, deltaX: 0, deltaMode: 0, bubbles: true, cancelable: true }));
  }

  var offTimer = null;
  function setOn(on) {
    if (on === state.on) return;
    state.on = on;
    clearTimeout(offTimer);
    if (on) {
      place(); render();
      ph.classList.remove('is-off'); void ph.offsetWidth; ph.classList.add('is-on');
      reveal();
    } else {
      /* putting the light out ends the film too */
      var showing = win.querySelector('.pw-tapes__showing'), stop = win.querySelector('.pw-tapes__stop');
      if (stop && ((showing && !showing.hidden) || (bar && !bar.hidden))) stop.click();
      ph.classList.remove('is-on'); ph.classList.add('is-off');
      offTimer = setTimeout(function () { ph.classList.remove('is-off'); }, 460);
    }
  }

  /* the projector switches the light, instead of opening the paper window */
  var downAt = null;
  document.addEventListener('pointerdown', function (e) {
    var o = e.target.closest && e.target.closest('.pw__object[data-opens="projector"]');
    downAt = o ? [e.clientX, e.clientY] : null;
  }, true);
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('.pw__object[data-opens="projector"]');
    if (!o || !ROOT.contains(o)) return;
    e.stopImmediatePropagation(); e.preventDefault();
    var real = e.isTrusted && e.detail > 0;
    if (real && downAt && Math.abs(e.clientX - downAt[0]) + Math.abs(e.clientY - downAt[1]) > 8) return;
    setOn(!state.on);
  }, true);
  document.addEventListener('dblclick', function (e) {
    if (!e.target.closest || !e.target.closest('.pw__screen')) return;
    e.stopImmediatePropagation(); e.preventDefault();
    setOn(true);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.on) setOn(false); });

  var mt = null;
  new MutationObserver(function () {
    if (!state.on) return;
    clearTimeout(mt); mt = setTimeout(render, 40);
  }).observe(win, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
  if (screenEl) new MutationObserver(placeBar).observe(screenEl, { attributes: true, attributeFilter: ['data-orientation'] });
  if (bar) new MutationObserver(function () { if (!bar.hidden) placeBar(); }).observe(bar, { attributes: true, attributeFilter: ['hidden'] });
  if (window.ResizeObserver) new ResizeObserver(place).observe(scene);
  window.addEventListener('resize', place);

  /* House lights. The room dims while a film plays and its picture is in
     view, and comes back up on pause, on stop, or when the visitor pans
     away. One flat sheet fading, so it costs the browser almost nothing. */
  var dim = document.createElement('div');
  dim.className = 'pw-dim';
  dim.setAttribute('aria-hidden', 'true');
  scene.insertBefore(dim, scene.firstChild);
  var playBtn = bar ? bar.querySelector('.pw-tapes__play') : null;
  var innerEl = screenEl ? screenEl.querySelector('.pw__screen-inner') : null;
  var vpBox = ROOT.querySelector('.pw__viewport');
  var dimRaf = null;
  function lights() {
    dimRaf = null;
    var on = false;
    var running = bar && !bar.hidden && playBtn && /pause/i.test(playBtn.getAttribute('aria-label') || '');
    if (running && innerEl && vpBox) {
      var v = vpBox.getBoundingClientRect(), r = innerEl.getBoundingClientRect();
      var seen = Math.min(r.right, v.right) - Math.max(r.left, v.left);
      on = r.width > 0 && seen / r.width > 0.4;
    }
    dim.classList.toggle('is-on', on);
  }
  function soon() { if (!dimRaf) dimRaf = requestAnimationFrame(lights); }
  /* while the world pans, look a few times a second rather than every frame */
  var panTimer = null;
  function whilePanning() { if (!panTimer) panTimer = setTimeout(function () { panTimer = null; soon(); }, 140); }
  if (bar) new MutationObserver(soon).observe(bar, { subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-label', 'class'] });
  new MutationObserver(whilePanning).observe(scene, { attributes: true, attributeFilter: ['style'] });
  window.addEventListener('resize', soon);

  place();
})();
